import { BrowserWindow } from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './symbols'
import { ISiteScrollBlockerServiceConfig } from '@wix/site-scroll-blocker-service'
import { isSSR } from '@wix/thunderbolt-commons'

const isPublicSegment = process.env.PACKAGE_NAME !== 'thunderbolt-ds'
const shouldBlockScrollWithoutVar = isPublicSegment

export const getSiteScrollBlockerConfig = (
	browserWindow: BrowserWindow,
	siteScrollBlockerExports: IFeatureExportsStore<typeof name>
): ISiteScrollBlockerServiceConfig => {
	return {
		browserWindow: browserWindow as Window,
		isSSR,
		onSiteScrollBlockChanged: (status) => {
			siteScrollBlockerExports.export({
				isScrollingBlocked: status,
			})
		},
		shouldBlockScrollWithoutVar,
	}
}
